import { connect } from 'react-redux'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { getCompletedProtracks } from 'store/entities/completedProtracks/actions'
import CompletedProTracks from './CompletedProTracks'

const mapDispatchToProps = {
  onRequest: getCompletedProtracks,
}

export default connect(null, mapDispatchToProps)(withDidMountRequest(CompletedProTracks))
